(() => {
  'use strict';

  // EDIT QUIZ CONTENT HERE: questions, answers, scoring, tie priority, and result copy.
  const QUIZ_CONFIG = {
    resultPriority: ['crayfish', 'salmon', 'grouper', 'pomfret', 'tiger-prawn', 'threadfin', 'scallop', 'oyster', 'octopus', 'squid', 'grey-prawn', 'mussel'],
    results: {
      salmon: {
        name: 'Salmon', article: 'A', emoji: '🐟', title: 'The Crowd Favourite',
        description: 'Warm, adaptable and naturally likeable. You read the room, bring people together and make everyone feel as though they belong at the table.',
        knowledge: { about: 'Salmon is an oil-rich fish recognised by its pink-orange flesh.', taste: 'Rich and buttery with firm, moist flakes.', cook: 'Pan-sear, bake, grill or gently poach it.', fact: 'Its distinctive colour comes from carotenoid pigments in its diet.' }
      },
      grouper: {
        name: 'Grouper', article: 'A', emoji: '🐟', title: 'The Steady Strategist',
        description: 'Calm waters, sharp instincts. You observe first, choose carefully and become the dependable anchor when everyone else starts drifting.',
        knowledge: { about: 'Grouper is a family of reef-associated fish with thick, meaty fillets.', taste: 'Mild and clean with firm, moist flakes.', cook: 'Steam it whole, pan-sear the fillet or add it to soup.', fact: 'Many groupers are patient ambush predators that wait for the right moment to strike.' }
      },
      pomfret: {
        name: 'Pomfret', article: 'A', emoji: '🐟', title: 'The Quiet Classic',
        description: 'Polished without trying too hard. You value quality, tradition and the kind of understated confidence that never needs an announcement.',
        knowledge: { about: 'Pomfret is a flat-bodied fish widely enjoyed in Asian home cooking.', taste: 'Mild and gently sweet with fine, delicate flakes.', cook: 'Steam it with aromatics, fry it crisp or cook it in curry.', fact: 'Its slim body cooks relatively quickly and takes seasoning well.' }
      },
      'tiger-prawn': {
        name: 'Tiger Prawn', article: 'A', emoji: '🦐', title: 'The Bold Spark',
        description: 'Energetic, expressive and ready to make an entrance. You turn ordinary plans into memorable occasions and bring the flavour wherever you go.',
        knowledge: { about: 'Tiger prawns are large prawns named for the dark bands across their shells.', taste: 'Succulent, firm and slightly sweet.', cook: 'Grill, stir-fry, barbecue or simmer them in curry.', fact: 'Their bold striped shells make them easy to recognise before cooking.' }
      },
      'grey-prawn': {
        name: 'Grey Prawn', article: 'A', emoji: '🦐', title: 'The Versatile All-Rounder',
        description: 'Practical, easygoing and quietly capable. You fit into any crowd, solve problems quickly and always have one more useful trick up your sleeve.',
        knowledge: { about: 'Grey prawn is a versatile everyday prawn suited to many familiar dishes.', taste: 'Mildly sweet and tender with a satisfying snap.', cook: 'Stir-fry, steam, add to noodles or serve in hotpot.', fact: 'The flesh becomes opaque and the shell changes colour as it cooks.' }
      },
      crayfish: {
        name: 'Crayfish', article: 'A', emoji: '🦞', title: 'The Main Character',
        description: 'Confident, ambitious and made for the centre of the table. You know what you want, raise the standard and turn an ordinary moment into an occasion.',
        knowledge: { about: 'Crayfish are freshwater crustaceans related to lobsters, with most of the meat in the tail and claws.', taste: 'Mildly sweet with firm, tender meat.', cook: 'Boil, grill or toss them through a rich, savoury sauce.', fact: 'Crayfish use their claws for feeding, defence and navigating their surroundings.' }
      },
      scallop: {
        name: 'Scallop', article: 'A', emoji: '🐚', title: 'The Refined Creative',
        description: 'Thoughtful, imaginative and tuned into the details. Your ideas feel fresh, your taste is precise and your calm exterior hides real depth.',
        knowledge: { about: 'A scallop is a bivalve mollusc; the round piece usually eaten is its adductor muscle.', taste: 'Delicate, sweet and buttery with a tender bite.', cook: 'Sear quickly, grill or steam until just cooked.', fact: 'Scallops can swim by rapidly opening and closing their shells.' }
      },
      mussel: {
        name: 'Mussel', article: 'A', emoji: '🐚', title: 'The Loyal Teammate',
        description: 'Grounded, generous and strongest with your people. You show up, pitch in and make every gathering feel warmer and more complete.',
        knowledge: { about: 'Mussels are bivalve shellfish that attach themselves to surfaces using strong threads.', taste: 'Briny, gently sweet and tender.', cook: 'Steam in broth, fold through pasta or cook with aromatics.', fact: 'A cluster of mussels can hold together even in moving coastal water.' }
      },
      oyster: {
        name: 'Oyster', article: 'AN', emoji: '🦪', title: 'The Mysterious Original',
        description: 'Selective, intriguing and never completely predictable. You protect your inner world, but the people who know you discover something truly special.',
        knowledge: { about: 'Oysters are bivalve shellfish that live in saltwater and brackish coastal habitats.', taste: 'Briny and mineral, with texture ranging from firm to creamy.', cook: 'Grill, bake or steam; follow the product instructions if serving raw.', fact: 'Some oyster species form reefs that provide habitat for other marine life.' }
      },
      threadfin: {
        name: 'Threadfin', article: 'A', emoji: '🐟', title: 'The Quiet Problem-Solver',
        description: 'Observant, resourceful and quietly protective. You notice what others miss, find the practical answer and look after your people without making a show of it.',
        knowledge: { about: 'Threadfin are named for the thread-like sensory rays beneath their pectoral fins.', taste: 'Clean and mild with soft, fine flakes.', cook: 'Steam, pan-fry or use it in comforting soups and porridge.', fact: 'Those thread-like rays help the fish detect food along the seabed.' }
      },
      octopus: {
        name: 'Octopus', article: 'AN', emoji: '🐙', title: 'The Master Multitasker',
        description: 'Curious, inventive and impressively flexible. You juggle moving parts with style and adapt faster than the situation can change.',
        knowledge: { about: 'An octopus is a soft-bodied cephalopod with eight arms and no internal shell.', taste: 'Mildly oceanic and satisfyingly meaty when tender.', cook: 'Braise until tender, then grill or sear for colour.', fact: 'An octopus has three hearts and can squeeze through remarkably small spaces.' }
      },
      squid: {
        name: 'Squid', article: 'A', emoji: '🦑', title: 'The Playful Explorer',
        description: 'Fast, curious and always ready to dive into something new. You follow your instincts, keep things lively and rarely choose the boring route.',
        knowledge: { about: 'Squid are cephalopods with eight arms, two longer tentacles and an internal flexible pen.', taste: 'Mild and slightly sweet with a clean, springy bite.', cook: 'Cook very quickly over high heat or slowly until tender.', fact: 'Squid can rapidly change colour using specialised skin cells called chromatophores.' }
      }
    },
    questions: [
      {
        text: 'A group dinner is happening. What role do you naturally take?',
        answers: [
          { text: 'Book the table and quietly take charge', scores: { crayfish: 3, pomfret: 2, salmon: 1 }, secondary: { crayfish: 2 } },
          { text: 'Order extra so everyone gets a share', scores: { mussel: 3, threadfin: 2, 'grey-prawn': 1 }, secondary: { mussel: 2 } },
          { text: 'Suggest the dish nobody has tried before', scores: { squid: 3, octopus: 2, 'tiger-prawn': 1 }, secondary: { squid: 2 } },
          { text: 'Read the room and choose exactly the right thing', scores: { grouper: 3, scallop: 2, oyster: 1 }, secondary: { grouper: 2 } }
        ]
      },
      {
        text: 'Your phone is at 5% and you are nowhere near home. You…',
        answers: [
          { text: 'Find a charger, a socket and a backup plan', scores: { octopus: 3, grouper: 2, threadfin: 1 }, secondary: { octopus: 2 } },
          { text: 'Announce the crisis and make it entertaining', scores: { 'tiger-prawn': 3, squid: 2, salmon: 1 }, secondary: { 'tiger-prawn': 2 } },
          { text: 'Switch it off and enjoy being unreachable', scores: { oyster: 3, pomfret: 2, scallop: 1 }, secondary: { oyster: 2 } },
          { text: 'Borrow a power bank and repay the favour later', scores: { 'grey-prawn': 3, mussel: 2, crayfish: 1 }, secondary: { 'grey-prawn': 2 } }
        ]
      },
      {
        text: 'Pick the dish that sounds most like your energy.',
        answers: [
          { text: 'Small, refined and perfectly executed', scores: { scallop: 3, oyster: 2, crayfish: 1 }, secondary: { scallop: 2 } },
          { text: 'A familiar favourite everyone wants a bite of', scores: { salmon: 3, mussel: 2, 'grey-prawn': 1 }, secondary: { salmon: 2 } },
          { text: 'A timeless whole fish with no unnecessary fuss', scores: { pomfret: 3, grouper: 2, threadfin: 1 }, secondary: { pomfret: 2 } },
          { text: 'A comforting bowl that quietly saves the day', scores: { threadfin: 3, salmon: 2, mussel: 1 }, secondary: { threadfin: 2 } }
        ]
      },
      {
        text: 'When plans suddenly change, you…',
        answers: [
          { text: 'Pause, assess and make a better plan', scores: { grouper: 3, threadfin: 2, pomfret: 1 }, secondary: { grouper: 2 } },
          { text: 'Turn the detour into the best part', scores: { squid: 3, 'tiger-prawn': 2, salmon: 1 }, secondary: { squid: 2 } },
          { text: 'Keep everyone calm and moving together', scores: { mussel: 3, salmon: 2, 'grey-prawn': 1 }, secondary: { mussel: 2 } },
          { text: 'Step back until the right answer becomes clear', scores: { oyster: 3, scallop: 2, octopus: 1 }, secondary: { oyster: 2 } }
        ]
      },
      {
        text: 'A friend calls with a late-night problem. Your first move?',
        answers: [
          { text: 'Turn the mess into three practical next steps', scores: { threadfin: 3, grouper: 2, 'grey-prawn': 1 }, secondary: { threadfin: 2 } },
          { text: 'Show up with food and no judgement', scores: { salmon: 3, mussel: 2, pomfret: 1 }, secondary: { salmon: 2 } },
          { text: 'Ask the one question that changes everything', scores: { octopus: 3, scallop: 2, oyster: 1 }, secondary: { octopus: 2 } },
          { text: 'Deliver the bold pep talk they need', scores: { 'tiger-prawn': 3, crayfish: 2, squid: 1 }, secondary: { 'tiger-prawn': 2 } }
        ]
      },
      {
        text: 'Which holiday souvenir are you most likely to bring home?',
        answers: [
          { text: 'A list of local dishes to recreate at home', scores: { pomfret: 3, threadfin: 2, salmon: 1 }, secondary: { pomfret: 2 } },
          { text: 'A story nobody quite believes', scores: { squid: 3, 'tiger-prawn': 2, octopus: 1 }, secondary: { squid: 2 } },
          { text: 'One beautifully made object', scores: { scallop: 3, oyster: 2, grouper: 1 }, secondary: { scallop: 2 } },
          { text: 'The upgrade you definitely did not budget for', scores: { crayfish: 3, 'grey-prawn': 2, mussel: 1 }, secondary: { crayfish: 2 } }
        ]
      },
      {
        text: 'A complicated task lands on your desk. You…',
        answers: [
          { text: 'Break it into steps and start with the solid bit', scores: { grouper: 3, threadfin: 2, pomfret: 1 }, secondary: { grouper: 2 } },
          { text: 'Move fast and build momentum', scores: { 'tiger-prawn': 3, crayfish: 2, squid: 1 }, secondary: { 'tiger-prawn': 2 } },
          { text: 'Find the clever shortcut nobody noticed', scores: { 'grey-prawn': 3, octopus: 2, scallop: 1 }, secondary: { 'grey-prawn': 2 } },
          { text: 'Bring the right people together', scores: { mussel: 3, salmon: 2, oyster: 1 }, secondary: { mussel: 2 } }
        ]
      },
      {
        text: 'Which compliment feels most like you?',
        answers: [
          { text: 'You are the person people can count on', scores: { threadfin: 3, grouper: 2, mussel: 1 }, secondary: { threadfin: 2 } },
          { text: 'You have effortless taste', scores: { pomfret: 3, scallop: 2, oyster: 1 }, secondary: { pomfret: 2 } },
          { text: 'You make everything more fun', scores: { salmon: 3, 'tiger-prawn': 2, squid: 1 }, secondary: { salmon: 2 } },
          { text: 'You spot the solution before everyone else', scores: { octopus: 3, 'grey-prawn': 2, crayfish: 1 }, secondary: { octopus: 2 } }
        ]
      },
      {
        text: 'It is Friday at 7pm. What sounds right?',
        answers: [
          { text: 'A booking at the place everyone is talking about', scores: { crayfish: 3, scallop: 2, 'tiger-prawn': 1 }, secondary: { crayfish: 2 } },
          { text: 'Whatever the group chat agrees on', scores: { 'grey-prawn': 3, salmon: 2, mussel: 1 }, secondary: { 'grey-prawn': 2 } },
          { text: 'No booking, no plan—just go', scores: { squid: 3, octopus: 2, 'tiger-prawn': 1 }, secondary: { squid: 2 } },
          { text: 'A quiet dinner with one or two favourite people', scores: { oyster: 3, grouper: 2, threadfin: 1 }, secondary: { oyster: 2 } }
        ]
      },
      {
        text: 'Finally, choose your superpower.',
        answers: [
          { text: 'Walk into any room and lift the energy', scores: { 'tiger-prawn': 3, crayfish: 2, salmon: 1 }, secondary: { 'tiger-prawn': 2 } },
          { text: 'Adapt instantly to anything', scores: { octopus: 3, squid: 2, 'grey-prawn': 1 }, secondary: { octopus: 2 } },
          { text: 'Make people feel safe and understood', scores: { threadfin: 3, grouper: 2, mussel: 1 }, secondary: { threadfin: 2 } },
          { text: 'Notice what everyone else misses', scores: { scallop: 3, oyster: 2, pomfret: 1 }, secondary: { scallop: 2 } }
        ]
      }
    ]
  };

  function chooseResult(answers) {
    const totals = Object.fromEntries(QUIZ_CONFIG.resultPriority.map((key) => [key, 0]));
    const secondary = Object.fromEntries(QUIZ_CONFIG.resultPriority.map((key) => [key, 0]));

    answers.forEach((answerIndex, questionIndex) => {
      const answer = QUIZ_CONFIG.questions[questionIndex]?.answers[answerIndex];
      if (!answer) return;
      Object.entries(answer.scores || {}).forEach(([key, points]) => { totals[key] += points; });
      Object.entries(answer.secondary || {}).forEach(([key, points]) => { secondary[key] += points; });
    });

    const highest = Math.max(...Object.values(totals));
    const leaders = QUIZ_CONFIG.resultPriority.filter((key) => totals[key] === highest);
    if (leaders.length === 1) return leaders[0];

    const secondaryHigh = Math.max(...leaders.map((key) => secondary[key]));
    return leaders.find((key) => secondary[key] === secondaryHigh);
  }

  function initQuiz(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const intro = root.querySelector('[data-quiz-view="intro"]');
    const quiz = root.querySelector('[data-quiz-view="quiz"]');
    const result = root.querySelector('[data-quiz-view="result"]');
    const questionHeading = root.querySelector('[data-quiz-question]');
    const answersWrap = root.querySelector('[data-quiz-answers]');
    const progressText = root.querySelector('[data-quiz-progress-text]');
    const progressBar = root.querySelector('[data-quiz-progress-bar]');
    const backButton = root.querySelector('[data-quiz-back]');
    const resultName = root.querySelector('[data-result-name]');
    const resultTitle = root.querySelector('[data-result-title]');
    const resultDescription = root.querySelector('[data-result-description]');
    const resultEmoji = root.querySelector('[data-result-emoji]');
    const knowledgeHeading = root.querySelector('[data-knowledge-heading]');
    const knowledgeAbout = root.querySelector('[data-knowledge-about]');
    const knowledgeTaste = root.querySelector('[data-knowledge-taste]');
    const knowledgeCook = root.querySelector('[data-knowledge-cook]');
    const knowledgeFact = root.querySelector('[data-knowledge-fact]');
    const shopSection = root.querySelector('[data-quiz-shop]');
    const shareStatus = root.querySelector('[data-share-status]');
    let currentQuestion = 0;
    let selectedAnswers = [];
    let activeResult = null;

    function showView(view) {
      [intro, quiz, result].forEach((item) => {
        item.hidden = item !== view;
        item.classList.remove('is-entering');
      });
      view.classList.add('is-entering');
    }

    function renderQuestion() {
      const item = QUIZ_CONFIG.questions[currentQuestion];
      questionHeading.textContent = item.text;
      progressText.textContent = `Question ${currentQuestion + 1} of ${QUIZ_CONFIG.questions.length}`;
      progressBar.style.width = `${((currentQuestion + 1) / QUIZ_CONFIG.questions.length) * 100}%`;
      progressBar.setAttribute('aria-valuenow', String(currentQuestion + 1));
      backButton.textContent = currentQuestion === 0 ? 'Back to intro' : 'Back';
      answersWrap.replaceChildren();

      item.answers.forEach((answer, answerIndex) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'seafood-quiz__answer';
        button.textContent = answer.text;
        button.setAttribute('aria-pressed', String(selectedAnswers[currentQuestion] === answerIndex));
        button.addEventListener('click', () => {
          selectedAnswers[currentQuestion] = answerIndex;
          answersWrap.querySelectorAll('button').forEach((option) => option.setAttribute('aria-pressed', 'false'));
          button.setAttribute('aria-pressed', 'true');
          window.setTimeout(() => {
            if (currentQuestion < QUIZ_CONFIG.questions.length - 1) {
              currentQuestion += 1;
              renderQuestion();
              questionHeading.focus();
            } else {
              displayResult(chooseResult(selectedAnswers));
            }
          }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180);
        });
        answersWrap.append(button);
      });
    }

    function displayResult(key) {
      const content = QUIZ_CONFIG.results[key];
      if (!content) return;
      activeResult = key;
      resultName.textContent = `YOU’RE ${content.article} ${content.name} ${content.emoji}`;
      resultTitle.textContent = content.title;
      resultDescription.textContent = content.description;
      resultEmoji.textContent = content.emoji;
      knowledgeHeading.textContent = `Get to know ${content.name}`;
      knowledgeAbout.textContent = content.knowledge.about;
      knowledgeTaste.textContent = content.knowledge.taste;
      knowledgeCook.textContent = content.knowledge.cook;
      knowledgeFact.textContent = content.knowledge.fact;
      const matchingProducts = root.querySelector(`[data-result-products="${CSS.escape(key)}"]`);
      root.querySelectorAll('[data-result-products]').forEach((products) => { products.hidden = products !== matchingProducts; });
      shopSection.hidden = !matchingProducts?.querySelector('.seafood-quiz__product') && !matchingProducts?.querySelector('.seafood-quiz__empty-products');
      root.querySelectorAll('[data-result-image]').forEach((image) => { image.hidden = image.dataset.resultImage !== key; });
      const configuredImage = root.querySelector(`[data-result-image="${CSS.escape(key)}"] img`);
      resultEmoji.hidden = Boolean(configuredImage);
      shareStatus.textContent = '';
      showView(result);
      resultName.focus();
    }

    function startQuiz() {
      currentQuestion = 0;
      selectedAnswers = [];
      activeResult = null;
      renderQuestion();
      showView(quiz);
      questionHeading.focus();
    }

    root.querySelector('[data-quiz-start]').addEventListener('click', startQuiz);
    root.querySelector('[data-quiz-retake]').addEventListener('click', startQuiz);
    backButton.addEventListener('click', () => {
      if (currentQuestion === 0) {
        showView(intro);
        root.querySelector('[data-quiz-start]').focus();
        return;
      }
      currentQuestion -= 1;
      selectedAnswers = selectedAnswers.slice(0, currentQuestion + 1);
      renderQuestion();
      questionHeading.focus();
    });

    root.querySelector('[data-quiz-share]').addEventListener('click', async () => {
      if (!activeResult) return;
      const content = QUIZ_CONFIG.results[activeResult];
      const shareUrl = new URL(window.location.href);
      shareUrl.searchParams.set('result', activeResult);
      const shareData = { title: root.dataset.heading, text: `I’m ${content.name} — ${content.title}! What seafood are you?`, url: shareUrl.toString() };
      try {
        if (navigator.share) {
          await navigator.share(shareData);
          shareStatus.textContent = 'Result shared.';
        } else {
          await navigator.clipboard.writeText(shareData.url);
          shareStatus.textContent = 'Result link copied.';
        }
      } catch (error) {
        if (error.name !== 'AbortError') shareStatus.textContent = 'Could not copy the link. Please copy it from your browser address bar.';
      }
    });

    const linkedResult = new URLSearchParams(window.location.search).get('result');
    if (linkedResult && QUIZ_CONFIG.results[linkedResult]) displayResult(linkedResult);
  }

  function initAll() { document.querySelectorAll('[data-seafood-quiz]').forEach(initQuiz); }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { QUIZ_CONFIG, chooseResult };
})();
